<p>{{ "tenes que ingresar cliente" | uppercase }}</p>
